import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Img from 'gatsby-image/withIEPolyfill';
import SVG from 'react-inlinesvg';

import { T2R, T2B } from './Text';
import { media } from '../styles/constants';

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 4rem;

  @media (min-width: ${media.tabletPortrait}) {
    flex-direction: row;
    padding-bottom: 3rem;
  }

  p {
    margin-top: 0.5rem;
    word-break: break-word;
  }
`;

const ImgContainer = styled.div`
  display: flex;
  min-width: 12rem;
  margin-bottom: 2.5rem;

  @media (min-width: ${media.tabletPortrait}) {
    padding-right: 3.5rem;
  }

  img,
  svg {
    align-self: flex-end;
    width: 18rem;
    height: 15rem;

    @media (min-width: ${media.tabletPortrait}) {
      width: 12rem;
      height: 12rem;
    }
  }

  img {
    border-radius: 100%;
    object-fit: cover;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
`;

const renderImage = (imgSrc, imgAlt) => {
  if (typeof imgSrc === 'string') {
    if (imgSrc.includes('.svg')) {
      return (
        <SVG src={imgSrc}>
          <img src={imgSrc} alt={imgAlt} />
        </SVG>
      );
    } else {
      return <img src={imgSrc} alt={imgAlt} />;
    }
  }

  if (typeof imgSrc === 'object') {
    if (imgSrc.childImageSharp) {
      return <Img fixed={imgSrc.childImageSharp.fixed} alt={imgAlt} />;
    } else {
      return <img src={imgSrc.publicURL} alt={imgAlt} />;
    }
  }
};

const Description = ({ imgSrc, imgAlt, title, text }) => {
  return (
    <DescriptionContainer>
      <ImgContainer>{renderImage(imgSrc, imgAlt)}</ImgContainer>
      <TextContainer>
        {title && <T2B>{title}</T2B>}
        {text && <T2R as="p">{text}</T2R>}
      </TextContainer>
    </DescriptionContainer>
  );
};

Description.propTypes = {
  imgSrc: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  imgAlt: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  picture: PropTypes.string
};

export default Description;
